export default __webpack_public_path__ + "static/media/icon-empresa.6353274f.png";